/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ResubmitClaimStatusRequest
 */
import _ from 'lodash';
import { Button as AntButton, Tooltip, ButtonProps, App } from 'antd';
import { Redo } from '@icon-park/react';

import { MODAL_TYPES } from '../modal';
import useResubmitClaimStatusRequest from 'hooks/claim/mutate/useResubmitClaimStatusRequest';
import { CLAIM_WORK_STATES } from 'app-constants/claims/claimRequest';

const errorMessage = 'Claim status checks aren’t supported for this payer - Please track status updates manually.';

const ALLOWED_RESUBMIT_STATES: ClaimRequest.IClaimWorkState[] = [
	CLAIM_WORK_STATES.a_processing.value,
	CLAIM_WORK_STATES.a_info_req.value,
	CLAIM_WORK_STATES.a_adjudicated.value,
	CLAIM_WORK_STATES.a_payment_posted.value,
	CLAIM_WORK_STATES.ia_closed.value,
];
/**
 * ResubmitClaimStatusRequest
 *
 */
const ResubmitClaimStatusRequest: React.FC<
	{
		claimId: string;
		isClaimPayer: boolean;
		isTextButton?: boolean;
		label?: string | React.ReactNode;
		workState: ClaimRequest.IClaimWorkState;
	} & ButtonProps
> = ({ claimId, isClaimPayer, isTextButton, label, workState, ...restProps }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useResubmitClaimStatusRequest();

	const confirmSubmit = () => {
		if (isClaimPayer) {
			modal.confirm({
				...MODAL_TYPES.confirm,
				content: 'Are you sure you want to refresh the claim status?',
				okText: 'Proceed',
				onOk: () => mutateAsync({ claimId }),
			});
		} else {
			modal.error({
				...MODAL_TYPES.error,
				width: 500,
				content: errorMessage,
			});
		}
	};

	if (!_.includes(ALLOWED_RESUBMIT_STATES, workState)) {
		return null;
	}

	if (isTextButton) {
		return (
			<AntButton onClick={confirmSubmit} {...restProps}>
				{label || ''}
			</AntButton>
		);
	}

	return (
		<Tooltip title='Refresh Claim Status'>
			<AntButton color='default' onClick={confirmSubmit} icon={<Redo />} {...restProps} />
		</Tooltip>
	);
};
export { errorMessage };
export default ResubmitClaimStatusRequest;
